export default __webpack_public_path__ + "static/media/postman.955a7fc0.svg";